import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/NewAuth.css';

const RegisterTrainerSuccess = () => {
    const navigate = useNavigate();

    return (
        <div className="auth-container">
            <div className="auth-box">
                <h1>Wszystko przebiegło pomyślnie! </h1>
                <p>
                    Dziękujemy za skorzystanie z <strong>PetBoard</strong>!
                    Potwierdź proszę swoje konto poprzez link wysłany na Twój adres e-mail.
                    Po potwierdzeniu będziesz mógł zalogować się do systemu.
                </p>
                <div className="button-container">
                    <button
                        onClick={() => navigate('/')}
                        style={{
                            backgroundColor: '#7269FF',
                            borderRadius: '40px',
                            color: 'white',
                            padding: '12px 24px',
                            border: '1px solid #7269FF',
                            fontWeight: 'bold',
                            fontSize: '16px'
                        }}
                    >
                        Przejdź do strony głównej
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RegisterTrainerSuccess;